import { useSelector } from 'react-redux';
import { selectPeopleByPersonID } from 'reduxStore/people/selectors';
import { Flex, Typography } from 'zui/Antd';
import PersonProfileImage from '../PersonProfileImage';

const { Title, Text } = Typography;

const PersonProfileCard = ({ size = 45, personID }) => {
	const person = useSelector((state) => selectPeopleByPersonID(state, personID));
	// If person object is empty, return null
	if (!person || Object.keys(person).length === 0) {
		return null;
	}
	return (
		<Flex align='center' gap={12}>
			<PersonProfileImage
				size={size}
				photoUrl={person?.photoUrl || undefined}
				name={person?.displayName}
				entityName={'People'}
				shape={'circle'}
				edit={false}
			/>
			<Flex vertical>
				<Title level={5} style={{ margin: 0 }}>
					{person?.displayName}
				</Title>
				<Text>{person?.email}</Text>
			</Flex>
		</Flex>
	);
};

export default PersonProfileCard;
